import { render, staticRenderFns } from "./agence-google-ads-antony.vue?vue&type=template&id=ba4bfa84&scoped=true&"
import script from "./agence-google-ads-antony.vue?vue&type=script&lang=js&"
export * from "./agence-google-ads-antony.vue?vue&type=script&lang=js&"
import style0 from "./agence-google-ads-antony.vue?vue&type=style&index=0&id=ba4bfa84&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4bfa84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,TakeStock: require('/app/components/TakeStock.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
